<template lang="pug">
.all
  .header-top
    el-form.header_b(inline)
      el-form-item(label="总在线人数：")
        span(style="color: #000") {{ allNum }}
      el-form-item(label="区域：")
        el-select(v-model="searchKey.area", clearable, value-key="areaId", size="small", @change="changeArea")
          el-option(value, label="全部")
          el-option(v-for="item in areaList", :key="item", :label="item", :value="item")

      el-form-item(label="项目: ")
        el-select(v-model="prj.prjName", size="small", clearable, @change="changePrj")
          el-option(value, label="全部")
          el-option(v-for="item in curPrjList", :key="item.prjId", :label="item.prjName", :value="item.prjId")
      el-form-item(label="当前区域在线人数：", v-if="searchKey.area")
        span(style="color: #000") {{ curAreaNum }}
  .midd
    el-table.jk-table(
      ref="multipleTable",
      :data="tableData",
      highlight-current-row,
      :highlight-current-row="true",
      height="100%",
      border
    )
      template(slot="empty")
        img(:src="zanwu")
        p(style="font-size: 16px; color: #000; margin-top: 36px")
        | 暂无数据
      el-table-column(label="人员名称", prop="userName")
      el-table-column(label="区域", prop="area")
      el-table-column(label="项目", prop="prjName", show-overflow-tooltip, min-width="150px")
      el-table-column(label="IP", prop="ip", align="center")
      el-table-column(label="登录端", prop="clientType", align="center", min-width="150px")
      el-table-column(label="登录时间", prop="loginTime")
    .footer
      el-pagination(
        v-bind="pageAttrs",
        :current-page.sync="page.pageNo",
        :page-size.sync="page.pageSize",
        :total="page.totalCount",
        @current-change="getOnlineList",
        @size-change="getOnlineList()"
      )
</template>
<script>
import { mapState } from "vuex";
import linearStyle from "@/CommonDP/service/sysServer-service";
export default {
  name: "OnlineUserStatistics",
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: [],
      currentRow: {},
      searchKey: {
        area: ""
      },
      curAreaNum: "",
      pageAttrs: {
        layout: "total,sizes,prev,pager,next,jumper",
        pageSizes: [10, 20, 30, 50, 100, 150],
        size: "mini",
        background: true
      },
      prj: {
        prjName: ""
      },
      beginTime: "",
      endTime: "",
      prjList: [],
      value1: "",
      areaList: [],
      areaTitle: "",
      allNum: "",
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, prev, pager, next,jumper" // 分页组件
      }
    };
  },
  computed: {
    curPrjList() {
      return this.prjList.filter(item => item.provinceCity === this.searchKey.area);
    },
    queryParams() {
      return {
        areaId: this.searchKey.area || "",
        prjId: this.prj.prjName,
        beginTime: this.beginTime,
        endTime: this.endTime
      };
    },
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },

  mounted() {
    this.getOnlineList();
    this.getNum();
    this.getAreaList();
    this.getPrj();
  },
  methods: {
    changeArea(val) {
      console.log(val);
      this._area = val;
      this.prj.prjName = "";
      this.reset(val);
    },

    changePrj(val) {
      console.log(val);
      this.reset(this._area || "", val);
    },

    reset(area = "", prjId = "") {
      this.page.pageNo = 1;
      // this.getNum();
      this.getOnlineList(area, prjId);
    },

    async getAreaList() {
      const res = await linearStyle.areaList(this.enterpriseId);
      if (res.result == "0") {
        this.areaList = res.data;
      }
    },

    async getNum() {
      const params = {
        areaId: this.searchKey.area || "",
        prjId: this.prj.prjName
      };
      const { data } = await linearStyle.getSystemOnlineNum(params);
      this.allNum = data;
    },

    // 获取项目
    async getPrj() {
      const res = await linearStyle.getPrjList(this.enterpriseId);
      if (res.result == "0") {
        this.prjList = res.data;
      }
    },
    // 列表
    getOnlineList() {
      const params = {
        area: this.searchKey.area,
        prjId: this.prj.prjName,
        pageNum: this.page.pageNo,
        pageSize: this.page.pageSize
      };
      linearStyle.getSystemOnlineList(params).then(({ data, totalCount, totalPage }) => {
        this.page.totalCount = totalCount;
        this.page.totalPage = totalPage;
        this.tableData = data || [];
        this.curAreaNum = totalCount;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
}
.header-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: var(--middle-space)  var(--big-space) 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(235, 239, 255);
  .header_b {

  }
}
.export {
  margin-right: 15px;
  margin-top: 8px;
}
.el-form--inline {
  /deep/.el-form-item {
    margin-right: 25px;
  }
}
.flex-bwn {
  display: flex;
}
.midd {
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 var(--big-space);
  overflow: auto;
  display: flex;
  flex-direction: column;
  .jk-table{
    height: 1px;
    flex: 1 0 1px;
  }
  .footer {
    text-align: right;
    padding: var(--middle-space) 0;
  }
}
</style>
